import React, { useState, useEffect, FC } from 'react';

import { useBoolean } from '../../scenes/common/Hooks/useBoolean.hook';
import BackgroundImage from '../BackgroundImage';
import EditImageModal from '../EditImageModal';
import { getBase64 } from './getBase64';
import { SelectClubPictureLabel } from './SelectClubPictureLabel';

interface IProps {
  addPic: (pic: string) => void;
  image?: string;
  label?: string;
  helpText?: string;
  disabled?: boolean;
}

const ImagePicker: FC<IProps> = props => {
  const { label, helpText, disabled, addPic, image: propsImage } = props;

  const [base64, setBase64] = useState<string>();
  const [image, setImage] = useState<string>();
  const [modalIsOpen, , toggleModalIsOpen] = useBoolean(false);

  useEffect(() => {
    if (propsImage) {
      setImage(propsImage);
    }
  }, [propsImage]);

  const save = async (e: any): Promise<any> => {
    const file = e.target.files[0];
    const base64ToSet = await getBase64(file);

    setBase64(base64ToSet);
    toggleModalIsOpen();
  };

  const updateImage = (imageToSet: string): void => {
    setImage(imageToSet);
  };

  return (
    <div className="image-picker">
      <div className={`pick-file ${disabled && 'disabled'}`}>
        {image ? (
          <BackgroundImage src={image || ''} className="empty-select-pic" alt="bg-image">
            <SelectClubPictureLabel label={label} helpText={helpText} disabled={disabled} />
          </BackgroundImage>
        ) : (
          <div className="empty-select-pic">
            <SelectClubPictureLabel label={label} helpText={helpText} disabled={disabled} />
          </div>
        )}
      </div>

      <EditImageModal
        updateImage={updateImage}
        addPic={addPic}
        base64={base64 || ''}
        title="Edit Image"
        open={modalIsOpen}
        onClose={toggleModalIsOpen}
      />

      <input type="file" id="file-input" onChange={save} accept=".jpg,.jpeg,.png" hidden={true} />
    </div>
  );
};

export { ImagePicker };
